import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { HeadCell } from '../styled/TableHead';

class TableHeadCell extends React.Component {
  render() {
    const {
      content,
      inlineStyles,
      testId,
      ...rest
    } = this.props;
    return /*#__PURE__*/React.createElement(HeadCell, _extends({
      style: inlineStyles,
      "data-testid": testId && `${testId}--head--cell`
    }, rest, {
      tabIndex: rest.isSortable ? 0 : undefined
    }), /*#__PURE__*/React.createElement("span", null, content));
  }

}

_defineProperty(TableHeadCell, "defaultProps", {
  innerRef: () => {},
  inlineStyles: {}
});

export default TableHeadCell;